/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  LOCATIONS_ADD_REQUEST,
  LOCATIONS_ADD_REQUEST_SUCCESS,
  LOCATIONS_ADD_REQUEST_FAILURE,
  LOCATIONS_FETCH_REQUEST,
  LOCATIONS_FETCH_REQUEST_SUCCESS,
  LOCATIONS_FETCH_REQUEST_FAILURE,
  LOCATIONS_UPSERT_REQUEST,
  LOCATIONS_UPSERT_REQUEST_SUCCESS,
  LOCATIONS_UPSERT_REQUEST_FAILURE,
  LOCATIONS_DELETE_REQUEST,
  LOCATIONS_DELETE_REQUEST_SUCCESS,
  LOCATIONS_DELETE_REQUEST_FAILURE,
  LOCATIONS_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  locationsPayload: [],
  locationsLoading: false,
  locationsErrors: {},
  locationsPagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const locationReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case LOCATIONS_UPSERT_REQUEST:
    case LOCATIONS_ADD_REQUEST:
    case LOCATIONS_DELETE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case LOCATIONS_UPSERT_REQUEST_SUCCESS:
    case LOCATIONS_ADD_REQUEST_SUCCESS:
    case LOCATIONS_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case LOCATIONS_UPSERT_REQUEST_FAILURE:
    case LOCATIONS_ADD_REQUEST_FAILURE:
    case LOCATIONS_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case LOCATIONS_FETCH_REQUEST:
      return Object.assign({}, state, {
        locationsLoading: true,
      });

    case LOCATIONS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        locationsLoading: false,
        locationsPayload: action.data,
        locationsErrors: {},
        locationsPagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case LOCATIONS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        locationsLoading: false,
        locationsErrors: action.error,
      });

    case LOCATIONS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        locationsLoading: false,
        locationsErrors: {},
        locationsPayload: [],
      });

    default:
      return state;
  }
};

export default locationReducer;
